
<div class="padding-20 ui-g" id="c3_searchWizardModal">
  
  <app-campaign-3-kontable 
  *ngIf="wizardList && show.table"
  id="searchWizardTable"            
  [columns] = "[         
  { field: 'code', title: 'campaign.code' },
  { field: 'name', title: 'campaign.name' },
  { field: 'description', title: 'campaign.description' }
]"
     
  [paginationType]="paginationType"
  [showInfoButton]="false"            
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="true"
  [source]="wizardList"
  (onSelected)="onWizardSelected($event)"
  #wizardTable>

</app-campaign-3-kontable>  
 <br />
 <br />
 <br />
  
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-wizard/campaign-3-search-wizard.component.html